import AssetRegisterForm from './AssetRegisterForm'

export default AssetRegisterForm
